import FormUserTemporaryLocked from './FormUserTemporaryLocked';
import enhancer from './FormUserTemporaryLocked.enhancer';

export default enhancer(FormUserTemporaryLocked);
